import styled from 'styled-components';
import { baseVariables } from '../../styles';
import { toRem } from '@marriott/shared/mi-helper-utils';

const { spacers } = baseVariables;

export const CARD_WIDTH_PX = 343;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: ${toRem(CARD_WIDTH_PX)};
  max-width: ${toRem(CARD_WIDTH_PX)};
  overflow: hidden;
  color: inherit;
  background-color: var(--t-brand-bg-color);
  border-radius: var(--t-cards-border-radius);
  box-shadow: 0 0.25rem 1.25rem rgba(0, 0, 0, 0.07);
`;

export const ContentRow = styled.a`
  display: flex;
  align-items: flex-end;
  gap: ${spacers?.spacers?.[2] ?? '0.5rem'};
  padding: ${spacers?.spacers?.[4] ?? '1.5rem'};
  width: 100%;
  text-decoration: none;
  color: inherit;
  border-end-start-radius: var(--t-cards-border-radius);
  border-end-end-radius: var(--t-cards-border-radius);

  &:hover,
  &:focus,
  &:active,
  &:visited {
    color: inherit;
    text-decoration: none;
  }

  &:focus-visible {
    outline: none;
    box-shadow: inset 0 0 0 2px var(--t-brand-fg-color);
  }
`;

export const TextBlockWrapper = styled.div`
  flex: 1 1 auto;
  min-inline-size: 0;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
